module.exports = __webpack_public_path__ + "img/07.2592510e.jpg";